import {AddressDisplay} from "../../components/AddressForm";
import {PersonDisplay} from "../../components/PersonForm";
import React from 'react'
import {Link} from "react-router-dom";

function getCoopName(coop){
    switch (coop){
        case 'AGREEMENT':
            return "umowa";
        case 'NO_AGREEMENT':
            return "brak umowy";
        case 'ORDER':
            return "zlecenie";
        default:
            return "";
    }
}

export default function Building(props){

    this.props = props;

    this.id = props.id

    this.get = function(property, props){
        switch (property){
            case "address":
                return <AddressDisplay  address={this.props[property]}/>;
            case "persons":
                return this.props[property].map(person=><PersonDisplay key={person.id} person={person} />)
            case "cooperation":
                return getCoopName(this.props[property]);
            case "agreement_end_date":
                if(this.props.agreement_indefinite === 1)
                    return "nieokreślony";
            case "agreement_date":
            case "inspection_date":
                if(this.props[property] === '0000-00-00' || this.props[property] === undefined || this.props[property] === null)
                    return "";

                return new Date(this.props[property]).toLocaleDateString();
            case "inspection_frequency":
                if(this.props[property] === undefined || this.props[property] === null)
                    return "Nie określono";
                return  Math.floor(1/this.props[property])
            case "next_inspection_date":
                const nDate = this.getNextInspectionDate()
                const linkDate = nDate.toJSON().split('T')[0];

                return <Link to={`/calendar?date=${linkDate}`} >{nDate.toLocaleDateString()}</Link>;
            case "supervisor_team":
                const team = props.teams.find(v=>v.id === this.props.team_id)
                const color = (team !== undefined) ? team.color : "#fff";
                const number = (team !== undefined) ? team.number : ""
                return <div className={"text-center"}  style={{backgroundColor:color}}>{number}</div>
            case "inspections_grid":

                return this.props.inspections?.map((inspection, number)=>
                    <InspectionGrid key={number} inspection={inspection} />
                )
            default:
                return this.props[property];
        }
    }

    this.getValueForComparing = (key)=>{
        switch(key){
            case "inspections_grid":
                if(this.props.inspections.length>0)
                    return this.props.inspections[0].frequency;

                return 0;
            case "agreement_end_date":
            case "agreement_date":
            case "inspection_date":
            case "next_inspection_date":
                return this.getNextInspectionTime()
            default:
                return this.props[key];
        }
    }

    this.compareTo = (otherBuilding, property, order)=>{
        if(property === null || property === undefined)
            return 0;

        const valA = this.getValueForComparing(property);
        const valB = otherBuilding.getValueForComparing(property);
        let ordering = 1;


        if(valA === undefined || valB === undefined)
            return 0;

        if(valA === null || valB === null)
            return 0;

        if(valA === valB)
            return 0;

        if(order === 'desc')
            ordering = -1;


        return (valA > valB ? 1 : -1) * ordering;
    }

    this.perfomSearch = function(key, pattern){

        switch (key){
            case "address":
                const address = this.props[key]
                const addressKeys = Object.keys(address);
                return addressKeys.findIndex(adrKey=>pattern.test(address[adrKey])) > -1;
            case "next_inspection_date":
                const nextInsTime = this.getNextInspectionTime();
                if(nextInsTime=== undefined)
                    return false;

                let date = new Date(nextInsTime).toLocaleDateString();

                return pattern.test(date);
            default:
                if(this.props[key] === undefined)
                    return false;

                return pattern.test(this.props[key]);
        }
    }

    this.getNextInspectionDate = function(){
        let date = this.getNextInspectionTime();
        const inspectionDate = new Date();
        inspectionDate.setTime(date);
        return inspectionDate;
    }

    this.getNextInspectionTime = function(){
        let date = 0;

        this.props.inspections.forEach(i=>{
            let d = new Date(i.next_inspection_date).getTime()

            if(date === 0)
                return date = d;

            if(date > d)
                return date = d;
        })

        return date;
    }

    this.getSearchKeys = function (){
        return ['name','address', 'next_inspection_date', 'description', 'folder_num']
    }

    this.checkForSearchQuery = function(query){
        if(query === undefined || query.length <= 0)
            return true;

        const pattern = new RegExp(query,"gi");

        return this.getSearchKeys().findIndex(key=>this.perfomSearch(key, pattern)) > -1;
    }


    return this;
}

function InspectionGrid(props){
    const currentDate = new Date();
    const {inspection} = props;
    const events = inspection.events.filter(event=>{
        const eventDate = dateToArray(event.next_inspection_date);
        event.date = eventDate;

        return eventDate.year === currentDate.getFullYear();
    });

    const parts = [];
    for(let i=0; i<inspection.frequency; i++){
        const {date, className, state} = getEvent(events, inspection.frequency, i);
        const link = date === "brak przeglądu" ? `` :`/calendar?date=${date}`;

        parts.push(
            <Link key={i} to={link} title={date} className={`inspection_cell ${className} ${state} cursor-pointer`} />
        )
    }
    return <div className={`inspections_grid_div frequency_${inspection.frequency}`}>{parts}</div>
}

function getEvent(events, frequency, position){
    let event = undefined;
    let state = "";
    let date = "brak przeglądu"
    let className = "not_exists"
    let range, eventId;
    switch (frequency){
        case 1:
            range = [1+position*12, 1+(position+1)*12];
            event = events.find(e=>e.date.month >= range[0] && e.date.month < range[1])
            break;
        case 2:
            range = [1+position*6, 1+(position+1)*6];
            event = events.find(e=>e.date.month >= range[0] && e.date.month < range[1])
            break;
        case 4:
            range = [1+position*3, 1+(position+1)*3];
            event = events.find(e=>e.date.month >= range[0] && e.date.month < range[1])
            break;
        case 12:
            event = events.find(e=> e.date.month === position+1)
            break;
    }

    if(event){
        state = event.state;
        date = event.date.string;
        eventId = event.event_id
        className = "exists";
    }

    return {date:date, className:className, state:state, event_id:eventId}
}

function dateToArray(dateString){
    if(!dateString)
        return {year:0,month:0,day:0};

    const d = dateString.split('T')[0].split('-');

    return {year:Number(d[0]),month:Number(d[1]),day:Number(d[2]), string:dateString.split('T')[0]}
}